import { useCodesByOwner, useUserOnce } from "../../util/db";
import { Link } from "../../util/router";

export default function PeopleCardProgressEntry({ uid }) {
  const defaultAvatar = 'https://via.placeholder.com/150?text=Avatar';

  const {
    data: person,
    status: personStatus
  } = useUserOnce(uid);

  const {
    data: codes,
    status: codesStatus
  } = useCodesByOwner(uid);

  // Calculate opened vs unopened counts
  const openedCount = codes?.filter(c => c.opened).length || 0;
  const unopenedCount = codes?.filter(c => !c.opened).length || 0;

  return (
    <li className="relative grid grid-cols-3 sm:grid-cols-3 items-center rounded-lg gap-x-6 py-5 hover:bg-green-100">
      {(person && personStatus === "success") && (
        <>
          <div className="ml-4 flex min-w-0 gap-x-4">
            <img
              alt=""
              src={person.profilePhoto ? person.profilePhoto : defaultAvatar}
              className="h-12 w-12 flex-none rounded-full bg-gray-50"
            />
            <div className="min-w-0 flex-auto items-center">
              <p className="text-sm font-semibold leading-6 text-gray-900">
                <Link to="/teams/all">
                  <span className="absolute inset-x-0 -top-px bottom-0" />
                  {person.name}
                </Link>
              </p>
              <p className="hidden mt-1 sm:flex text-xs leading-5 text-gray-500">
                <a href={`mailto:${person.email}`} className="relative truncate hover:underline">
                  {person.email}
                </a>
              </p>
            </div>
          </div>
          <div className="mr-4 shrink-0 items-center gap-x-4">
            <div className="flex flex-col sm:flex-row items-center gap-1">
              {(codesStatus === "success") ? (
                <>
                  <p className="inline-flex items-center rounded-full bg-green-50 px-2 py-1 text-xs font-medium text-green-700 ring-1 ring-inset ring-green-600/20">
                    {openedCount} Opened
                  </p>
                  <p className="inline-flex items-center rounded-full bg-red-50 px-2 py-1 text-xs font-medium text-red-700 ring-1 ring-inset ring-red-600/20">
                    {unopenedCount} Unopened
                  </p>
                </>
              ) : (
                <p className="text-xs text-gray-500">Loading...</p>
              )}
            </div>
          </div>
          <div className="pr-2 sm:pr-0 w-full" aria-hidden="true">
            <div className='flex flex-row space-x-2 items-baseline'>
              <p className='font-semibold text-green-700'>
                {person.finishedContent ? (person.finishedContent.length * 10) : 0}%
              </p>
              <p className='text-xs text-gray-500'>of Webinars Finished</p>
            </div>
            <div className="overflow-hidden rounded-full bg-gray-200">
              <div
                className="h-2 rounded-full bg-green-700"
                style={{ width: `${person.finishedContent ? (person.finishedContent.length * 10) : 0}%` }}
              />
            </div>
          </div>
        </>
      )}
    </li>
  );
}
